(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reviews"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    const videoControls = document.querySelectorAll('.js-video-controls');
    const stickyAddToCart = document.querySelector('#bundle-sticky_add_to_cart');

    const toggleMuting = (el, videoEl) => {
      videoEl.muted = !videoEl.muted;
      el.classList.toggle('playing');
    };

    const openFullScreen = (parentWrapper) => {
      const shopifySection = parentWrapper.closest('.shopify-section');
      shopifySection.classList.add('full-screen');
      parentWrapper.classList.add('full-screen');
    };

    const closeFullScreen = (parentWrapper) => {
      const shopifySection = parentWrapper.closest('.shopify-section');
      shopifySection.classList.remove('full-screen');
      parentWrapper.classList.remove('full-screen');
    };

    const stopVideo = (videoEl, el) => {
      el.classList.toggle('playing');
      videoEl.muted = true;
      videoEl.pause();
    };

    const playVideo = (videoEl, el) => {
      el.classList.toggle('playing');
      videoEl.muted = false;
      videoEl.play();
    };

    

const videoReviewsContainer = document.querySelector('.video-reviews');
if (videoReviewsContainer) {
  const autoplayAll = videoReviewsContainer.dataset.autoplayAll === 'true';
  const autoplaySequential = videoReviewsContainer.dataset.autoplaySequential === 'true';
  const allVideos = videoReviewsContainer.querySelectorAll('.js-video');

  if (autoplayAll) {
    // Autoplay all simultaneously (muted) — overrides sequential
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          allVideos.forEach(v => { v.muted = true; v.play(); });
          observer.disconnect();
        } else {
          allVideos.forEach(v => v.pause());
        }
      });
    }, { threshold: 0.3 });
    observer.observe(videoReviewsContainer);

  } else if (autoplaySequential) {
  let currentIndex = 0;
  const pipEl = document.querySelector('.js-video-pip');
  const pipVideo = pipEl ? pipEl.querySelector('.js-pip-video') : null;
  const pipCounter = pipEl ? pipEl.querySelector('.js-pip-counter') : null;
  let isPipActive = false;
  let isPipDismissed = false;
  let isPlaying = false;
  let sectionIsVisible = false;

  const playNext = () => {
  if (currentIndex >= allVideos.length) currentIndex = 0;
  const video = allVideos[currentIndex];
  video.muted = true;
  video.loop = false;

  const onEnded = () => {
    currentIndex++;
    if (currentIndex >= allVideos.length) currentIndex = 0;
    playNext();
  };

  if (isPipActive && !sectionIsVisible) {
    syncPip(video);
    // Listen on PiP video, not inline
    pipVideo.removeEventListener('ended', onEnded); // prevent duplicates
    pipVideo.addEventListener('ended', onEnded, { once: true });
  } else {
    video.play();
    video.addEventListener('ended', onEnded, { once: true });
  }
};

  const startPlayback = () => {
    if (isPlaying) return;
    isPlaying = true;
    playNext();
  };

  // --- PiP ---
  const syncPip = (sourceVideo) => {
    if (!pipVideo) return;
    const source = sourceVideo.querySelector('source');
    const src = source ? source.src : sourceVideo.src;
    if (src && pipVideo.src !== src) {
      pipVideo.src = src;
    }
    pipVideo.muted = true;
    pipVideo.play();
    if (pipCounter) {
      pipCounter.textContent = `${currentIndex + 1} / ${allVideos.length}`;
    }
  };

  const showPip = () => {
    if (!pipEl || isPipDismissed || sectionIsVisible) return;
    isPipActive = true;
    pipEl.classList.add('active');
    startPlayback();
    const currentVideo = allVideos[currentIndex] || allVideos[0];
    syncPip(currentVideo);
    // Pause inline videos
    allVideos.forEach(v => v.pause());
  };

  const hidePip = () => {
    if (!pipEl) return;
    isPipActive = false;
    pipEl.classList.remove('active');
    if (pipVideo) pipVideo.pause();
  };

  // --- PiP controls ---
  if (pipEl) {
    pipEl.querySelector('.js-pip-close').addEventListener('click', (e) => {
      e.stopPropagation();
      isPipDismissed = true;
      hidePip();
    });

    pipEl.addEventListener('click', () => {
      videoReviewsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  // --- TRIGGER 1: ATC button leaves viewport → show PiP ---
  const atcButton = document.querySelector(
    '[name="add"], button[data-add-to-cart], .product-form__submit, #product-form button[type="submit"]'
  );

  if (atcButton && pipEl) {
    const atcObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          // ATC scrolled past → show PiP (unless video section is visible)
          showPip();
        } else {
          // ATC visible again → hide PiP
          hidePip();
        }
      });
    }, { threshold: 0, rootMargin: '0px' });
    atcObserver.observe(atcButton);
  }

  // --- TRIGGER 2: Video section enters viewport → inline playback, hide PiP ---
  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        sectionIsVisible = true;
        hidePip();
        // Resume/start inline playback
        if (isPlaying) {
          const video = allVideos[currentIndex] || allVideos[0];
          video.muted = true;
          video.play();
        } else {
          startPlayback();
        }
      } else {
        sectionIsVisible = false;
        // Section left viewport — if ATC also not visible, show PiP
        if (isPlaying && !isPipDismissed) {
          const atcRect = atcButton ? atcButton.getBoundingClientRect() : null;
          const atcVisible = atcRect && atcRect.bottom > 0 && atcRect.top < window.innerHeight;
          if (!atcVisible) {
            showPip();
            allVideos.forEach(v => v.pause());
          }
        }
      }
    });
  }, { threshold: 0.3 });
  sectionObserver.observe(videoReviewsContainer);
}
}

    videoControls.forEach((v) => {
      const parentWrapper = v.parentNode;
      const videoEl = parentWrapper.querySelector('.js-video');
      const videoPlayer = parentWrapper.querySelector('.js-video-player');

      v.addEventListener('click', (e) => {
        if (!e.target.nodeName === 'BUTTON') return;

        if (e.target.classList.contains('js-full-screen-opener')) {
          openFullScreen(parentWrapper);
          playVideo(videoEl, e.target);
          videoPlayer.classList.toggle('playing');
        }

        if (e.target.classList.contains('js-full-screen-closer')) {
          closeFullScreen(parentWrapper);
          stopVideo(videoEl, e.target);
          videoPlayer.classList.toggle('playing');
        }

        if (e.target.classList.contains('js-sound-player')) {
          toggleMuting(e.target, videoEl);
        }

        if (e.target.classList.contains('js-video-player')) {
          e.target.classList.contains('playing') ? stopVideo(videoEl, e.target) : playVideo(videoEl, e.target);
        }
      });
    });


    const videos = document.querySelectorAll('.js-video');

    videos.forEach(video => {
      video.currentTime = 0.001;
      const source = video.querySelector('source')
      const src = source.src
      source.src = src + '#t=0.001'
    }
    )
  });

  } catch(e) { console.error(e); }
})();
})();
